module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isReady && !_vm.isLoading) ? _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('menu-comp'), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "css": false
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('router-view')], 1)], 1) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-01b129bd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/App.vue
 ** module id = 743
 ** module chunks = 2
 **/